import { Component, Inject, Vue, Prop, Watch } from "vue-property-decorator";
import { UserTemplateService } from "../../services/UserTemplateService";
import { STYLE_CLASSES } from "../../../../shared/constants/StyleConstants";
import {
  NAME_FIELD,
  USER_TEMP_CONSTANTS,
  VISUAL_ELEMENT_TYPE,
  USER_TEMPLATES_ACCESS
} from "../../constants/UserTemplateConstants";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  LIST_DATA_EVENTS
} from "../../../../shared/constants/FormConstants";
import { Http } from "@status/codes";
import { UserTemplate } from "../../models/UserTemplate";
import EmptyState from "../../../../shared/components/EmptyState/EmptyState.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { InfoGroupService } from "../../../InfoGroup/services/InfoGroupService";
import { HeaderInfoGroup } from "../../../InfoGroup/models/HeaderInfoGroup";
import ModalTemplate from "../../../../shared/components/ModalTemplate/ModalTemplate.vue";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import { InfoGroupDetail } from "../../../InfoGroup/models/InfoGroupDetail";
import {
  INFO_GROUPS_ACCESS,
  INFO_GROUP_CONSTANTS
} from "../../../InfoGroup/constants/InfoGroupConstants";
import { FullSchema } from "../../../../shared/models/FullSchema";
import { Utils } from "@/shared/utils/utils";
import WarningDeleteMessage from "@/shared/components/WarningDeleteMessage/WarningDeleteMessage.vue";
import {
  STATE,
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { InfoGroupQuerySend } from "@/modules/InfoGroup/models/InfoGroupQuerySend";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import { InfoGroupModel } from "@/modules/InfoGroup/models/InfoGroup";
import SaveInfoGroup from "../../../InfoGroup/components/SaveInfoGroup/SaveInfoGroup.vue";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { UserTemplateForm } from "../../models/UserTemplateForm.model";

@Component({
  components: {
    EmptyState,
    ModalTemplate,
    FormModalViewer,
    WarningDeleteMessage,
    SaveInfoGroup,
    DynamicSelect
  }
})
export default class SaveUserTemplate extends Vue {
  @Inject() userTemplateService!: UserTemplateService;
  @Inject() infoGroupService!: InfoGroupService;
  @Prop() private userTemplateIdProp!: string;
  @Prop({ default: true, required: false })
  public isModal!: boolean;

  PAGE_TITLE = USER_TEMP_CONSTANTS.ADD_PAGE_TITLE;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  USER_TEMP_NAME = USER_TEMP_CONSTANTS.LABEL.USER_TEMP_NAME;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  PREVIEW_BTN = FORM_CONSTANTS.BUTTON.PREVIEW;
  GROUPS_TITLE = USER_TEMP_CONSTANTS.GROUPS_TITLE;
  HINT_GROUP = USER_TEMP_CONSTANTS.LABEL.HINT_GROUP;
  SEARCH_GROUP = USER_TEMP_CONSTANTS.LABEL.SEARCH_GROUP;
  HINT_SEARCH_GROUP = USER_TEMP_CONSTANTS.LABEL.HINT_SEARCH_GROUP;
  ADD_GROUP = USER_TEMP_CONSTANTS.LABEL.ADD_GROUP;
  USER_TEMP_VISUAL_ELEMENT = USER_TEMP_CONSTANTS.LABEL.VISUAL_ELEM;
  USER_TEMP_DESC = USER_TEMP_CONSTANTS.LABEL.USER_TEMP_DESC;
  USER_TEMP_STATE = FORM_CONSTANTS.LABEL.STATE;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  MORE_INFO = FORM_CONSTANTS.BUTTON.MORE_INFO;
  USER_TEMP_INFO = USER_TEMP_CONSTANTS.LABEL.USER_TEMP_INFO;
  GROUP_NAME = USER_TEMP_CONSTANTS.LABEL.NAME_GROUP_TEXT;
  GROUP_STATE = USER_TEMP_CONSTANTS.LABEL.STATE_GROUP_TEXT;
  INFO_GROUP_BASIC_ID = INFO_GROUP_CONSTANTS.INFO_GROUP_BASIC_ID;
  NO_GROUP_FOUND = USER_TEMP_CONSTANTS.LABEL.NO_GROUP_FOUND;
  SHOW_USER_TEMPLATE = "showUserTemplate";
  REFRESH_USER_TEMPLATE = "refreshUserTemplates";

  cardClass = STYLE_CLASSES.CARD;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  switchClass = STYLE_CLASSES.SWITCH;

  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  requiredSelectedOne = [this.selectAtLeastOne()];

  modalDialogUserTemp = false;
  modalTitleUserTemp = "";
  modalTextUserTemp = "";
  infoGroupData: InfoGroupDetail = new InfoGroupDetail();
  searchFilter = "";
  dialogPreview = false;
  userTemplateForm = false;
  visualElementModel = [{ id: "", name: "" }];
  visualElementList = VISUAL_ELEMENT_TYPE;
  userTemplate: UserTemplate = new UserTemplate();
  show: boolean[] = [];
  groupActive = "";
  listNameGroup: HeaderInfoGroup[] = [];
  activeSearchSchema = true;
  clearModel = false;
  componentPreviewKey = 0;
  isEditing = false;
  userTempRef = "";
  showMoreInfo = false;
  ELEMENT_INACTIVE = STYLE_CLASSES.OUTTER_BORDER_ELEMENT_VOIDED;
  STATE = STATE;
  CREATE_INFO_GROUP = USER_TEMP_CONSTANTS.DIALOG_MESSAGE.CREATE_INFO_GROUP;
  noData = false;
  showModalAddList = false;
  errorsName: string[] = [];

  userTemplateSelectConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    listAll: [],
    filled: false,
    messageLabel: this.ADD_GROUP,
    hint: this.HINT_GROUP,
    persistenthint: true,
    chips: true,
    notFound: false,
    loadingData: true
  };

  visualElementSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.visualElementList.map(element => {
      return { id: element.value, name: element.label };
    }),
    messageLabel: this.USER_TEMP_VISUAL_ELEMENT,
    required: true
  };
  lastRef = "";

  userTemplateFormData: UserTemplateForm = {
    userTempName: "",
    userTempDescription: "",
    versionUserTemp: 1,
    state: true,
    visualElement: "",
    groupsChosen: []
  };

  editComparationStr = "";
  invalidEdit = false;

  get visualElement() {
    return this.visualElementModel[0].id;
  }

  set visualElement(id: string) {
    const visualElement = this.visualElementList.find(item => item.value == id);
    this.visualElementModel = [
      { id: visualElement?.value ?? "", name: visualElement?.label ?? "" }
    ];
  }

  async mounted() {
    await this.changeFormTemplate();
  }
  @Watch("visualElement")
  visulElementUpdate() {
    this.userTemplateFormData.visualElement =
      this.visualElementModel[0].id ?? "";
  }

  @Watch("userTemplateFormData", { deep: true })
  checkEdit() {
    if (this.isEditing) {
      this.invalidEdit =
        JSON.stringify(this.userTemplateFormData) === this.editComparationStr;
    }
  }
  @Watch("userTemplateIdProp")
  async changeFormTemplate() {
    this.lastRef = "";
    if (!this.isModal) {
      this.goToStart("userTemplateForm");
    }
    if (this.userTemplateIdProp) {
      this.userTempRef = this.userTemplateIdProp;
      this.userTemplateFormData.groupsChosen = [];
      await this.getUserTempData();
      this.isEditing = true;
      this.PAGE_TITLE = USER_TEMP_CONSTANTS.EDIT_PAGE_TITLE;
      this.userTemplateSelectConfig.notFound = false;
    } else {
      this.isEditing = false;
    }
    await this.initialLoad();
    await this.loadInactiveGroups();
  }

  async initialLoad() {
    await this.loadGroups();
    await this.getBasicInfoGroup();

    const basicInfo = this.listNameGroup.find(
      g => g._key === this.INFO_GROUP_BASIC_ID
    );

    const existBasicInfoGroup = this.userTemplateFormData.groupsChosen.find(
      g => g._key === this.INFO_GROUP_BASIC_ID
    );

    if (basicInfo) {
      if (!existBasicInfoGroup) {
        basicInfo.id = basicInfo._key;
        this.userTemplateFormData.groupsChosen.push(basicInfo);
      }
    } else {
      this.listNameGroup = [];
      Snackbar.popError(
        USER_TEMP_CONSTANTS.DIALOG_MESSAGE.INFO_GROUP_NOT_FOUND
      );
    }
    this.setInfoGroupList();
  }

  setInfoGroupList() {
    this.userTemplateSelectConfig.listAll = this.listNameGroup.map(item => {
      return {
        id: item._key,
        name: item.name,
        description: item.description,
        state: item.state
      };
    });
    const defaultInfoGroup = this.listNameGroup.filter(
      item => item._key == this.INFO_GROUP_BASIC_ID
    );
    this.userTemplateSelectConfig.default = defaultInfoGroup.map(item => {
      return {
        id: item._key,
        name: item.name,
        state: item.state
      };
    });
  }
  async getBasicInfoGroup() {
    try {
      const existBasicInfo = this.listNameGroup.find(
        g => g._key === this.INFO_GROUP_BASIC_ID
      );

      if (existBasicInfo) return;

      const responseData = await this.infoGroupService.getInfoGroupById(
        this.INFO_GROUP_BASIC_ID
      );

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const basicInfoGroup: HeaderInfoGroup = {
          _key: this.INFO_GROUP_BASIC_ID,
          name: responseData.data.visualName ?? responseData.data.name,
          description: responseData.data.description,
          state: responseData.data.state,
          id: this.INFO_GROUP_BASIC_ID
        };
        this.listNameGroup.push(basicInfoGroup);
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${INFO_GROUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  @Watch("userTemplateFormData.groupsChosen")
  changeValue() {
    if (
      !this.userTemplateFormData.groupsChosen.find(
        g => g._key === this.INFO_GROUP_BASIC_ID
      )
    ) {
      const basicInfo = this.listNameGroup.find(
        g => g._key === this.INFO_GROUP_BASIC_ID
      );
      if (basicInfo) {
        basicInfo.id = basicInfo?._key;
        this.userTemplateFormData.groupsChosen.push(basicInfo);
      }
    }

    this.userTemplateFormData.groupsChosen.forEach(item => {
      if (item.id) item._key = item.id;
    });

    this.activeSearch();
  }

  async getUserTempData() {
    try {
      const resultUserTemplate = await this.userTemplateService.getUserTemplateInfo(
        this.userTempRef
      );
      if (resultUserTemplate.code === Http.Found && resultUserTemplate.data) {
        this.userTemplateFormData.userTempName = resultUserTemplate.data.name;
        this.userTemplateFormData.userTempDescription =
          resultUserTemplate.data.description;
        this.userTemplateFormData.versionUserTemp =
          resultUserTemplate.data.version ?? 1;
        this.userTemplateFormData.state =
          resultUserTemplate.data.state === FORM_CONSTANTS.STATE.ACTIVE
            ? true
            : false;
        this.visualElement = resultUserTemplate.data.visualElement;
        this.userTemplateFormData.visualElement =
          resultUserTemplate.data.visualElement;
        this.userTemplateFormData.groupsChosen = (resultUserTemplate.data
          .infoGroups as HeaderInfoGroup[]).map(item => {
          item.id = item._key;
          return item;
        });
        this.editComparationStr = JSON.stringify(this.userTemplateFormData);
        this.isEditing = true;
      } else {
        this.$emit(this.SHOW_USER_TEMPLATE, false);
        Snackbar.popError(resultUserTemplate.message);
      }
    } catch (error) {
      this.$emit(this.SHOW_USER_TEMPLATE, false);
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  selectAtLeastOne(): (value: string) => boolean | string {
    return () =>
      this.userTemplateFormData.groupsChosen.length > 0 ||
      USER_TEMP_CONSTANTS.RULES_MESSAGE.MIN_ONE_GROUP;
  }

  async confirmDialog(isSave: boolean) {
    if (isSave) {
      if (this.isEditing) {
        this.updateUserTemplateModal();
      } else {
        await this.saveUserTemplateModal();
      }
    } else {
      this.$emit(USER_TEMP_CONSTANTS.CLOSE_MODAL);
    }
  }

  async handleModalAccept() {
    this.modalDialogUserTemp = false;

    if (this.modalTitleUserTemp === FORM_MESSAGES.SAVE_MODAL.TITLE) {
      if (this.isEditing) {
        await this.updateUserTemplateForm();
      } else {
        await this.saveUserTemplateForm();
      }
    } else if (this.modalTitleUserTemp === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      this.$emit(USER_TEMP_CONSTANTS.CLOSE_MODAL);
    }
  }

  showModalAddGroup() {
    Utils.changeStateList(this, USER_TEMP_CONSTANTS.USER_TEM_SELECT, false);
    this.showModalAddList = true;
  }

  handleModalCancel() {
    this.modalDialogUserTemp = false;
  }

  async userTemplateExist(): Promise<boolean> {
    const responseData = await this.userTemplateService.checkIfExistByName(
      this.userTemplateFormData.userTempName.trim()
    );

    if (responseData.code === Http.NotFound) {
      return false;
    } else if (responseData.code === Http.Found) {
      return true;
    } else {
      throw Error();
    }
  }

  async saveUserTemplateModal(): Promise<void> {
    try {
      const exist = await this.userTemplateExist();
      const basicInfo = this.userTemplateFormData.groupsChosen.filter(
        g => g._key === this.INFO_GROUP_BASIC_ID
      );

      if (exist) {
        Snackbar.popWarning(
          USER_TEMP_CONSTANTS.DIALOG_MESSAGE.USER_TEMP_NAME_EXIST
        );
      } else if (basicInfo.length == 0) {
        Snackbar.popWarning(
          USER_TEMP_CONSTANTS.DIALOG_MESSAGE.BASIC_INFO_REQUIRED
        );
      } else {
        this.modalTitleUserTemp = FORM_MESSAGES.SAVE_MODAL.TITLE;
        this.modalTextUserTemp = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
        this.modalDialogUserTemp = true;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  updateUserTemplateModal() {
    const basicInfo = this.userTemplateFormData.groupsChosen.filter(
      g => g._key === this.INFO_GROUP_BASIC_ID
    );

    if (basicInfo.length == 0) {
      Snackbar.popWarning(
        USER_TEMP_CONSTANTS.DIALOG_MESSAGE.BASIC_INFO_REQUIRED
      );
    } else {
      this.modalTitleUserTemp = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalTextUserTemp = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
      this.modalDialogUserTemp = true;
    }
  }

  async saveUserTemplateForm() {
    try {
      if (this.userTemplateFormData.userTempName.trim() !== "") {
        this.userTemplate = {
          name: this.userTemplateFormData.userTempName.trim(),
          description: this.userTemplateFormData.userTempDescription,
          state: this.userTemplateFormData.state
            ? FORM_CONSTANTS.STATE.ACTIVE
            : FORM_CONSTANTS.STATE.INACTIVE,
          infoGroups: this.userTemplateFormData.groupsChosen.map(
            group => group._key
          ),
          visualElement: this.visualElement,
          createdBy: localStorage.getItem("UID")
        };
        const response = await this.userTemplateService.addUserTemplate(
          this.userTemplate
        );

        if (response.code == Http.Ok) {
          Snackbar.popSuccess(response.message);
          this.$emit(this.REFRESH_USER_TEMPLATE, this.userTemplate.name);
          this.$emit(this.SHOW_USER_TEMPLATE, false);
        } else {
          Snackbar.popError(
            USER_TEMP_CONSTANTS.DIALOG_MESSAGE.ERROR_SAVE_USER_TEMP
          );
        }
      } else {
        Snackbar.popError(
          USER_TEMP_CONSTANTS.DIALOG_MESSAGE.EMPTY_USER_TEMP_NAME
        );
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_TEMPLATES_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async updateUserTemplateForm() {
    try {
      if (this.userTemplateFormData.userTempName.trim() !== "") {
        this.userTemplate = {
          name: this.userTemplateFormData.userTempName.trim(),
          description: this.userTemplateFormData.userTempDescription,
          state: this.userTemplateFormData.state
            ? FORM_CONSTANTS.STATE.ACTIVE
            : FORM_CONSTANTS.STATE.INACTIVE,
          infoGroups: this.userTemplateFormData.groupsChosen.map(
            group => group._key
          ),
          visualElement: this.visualElement,
          changedBy: localStorage.getItem("UID"),
          version: this.userTemplateFormData.versionUserTemp
        };
        const response = await this.userTemplateService.updateUserTemplate(
          this.userTempRef,
          this.userTemplate
        );

        if (response.code == Http.Ok) {
          Snackbar.popSuccess(response.message);
          this.$emit(this.REFRESH_USER_TEMPLATE);
          this.$emit(this.SHOW_USER_TEMPLATE, false);
        } else {
          Snackbar.popError(
            USER_TEMP_CONSTANTS.DIALOG_MESSAGE.ERROR_SAVE_USER_TEMP
          );
        }
      } else {
        Snackbar.popError(
          USER_TEMP_CONSTANTS.DIALOG_MESSAGE.EMPTY_USER_TEMP_NAME
        );
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_TEMPLATES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  deleteGroup(index: number) {
    if (
      this.userTemplateFormData.groupsChosen[index]._key ===
      this.INFO_GROUP_BASIC_ID
    )
      return;

    this.userTemplateFormData.groupsChosen.splice(index, 1);
    this.activeSearchSchema = true;

    if (this.infoGroupData.schema) {
      this.infoGroupData.schema.allOf.splice(index, 1);
    }
    this.componentPreviewKey = this.componentPreviewKey + 1;
  }

  async handleGroups(name: string) {
    this.userTemplateSelectConfig.loadingData = true;
    this.userTemplateSelectConfig.notFound = false;
    const responseData = await this.infoGroupService.getInfoGroupByFilters({
      name
    });
    if (responseData.code === Http.Found && responseData.data) {
      responseData.data.groups.forEach(group => {
        if (group._key !== this.INFO_GROUP_BASIC_ID)
          this.listNameGroup.push(group);
        this.setInfoGroupList();
      });
    } else {
      this.userTemplateSelectConfig.notFound = true;
    }
    this.userTemplateSelectConfig.loadingData = false;
  }

  @Watch("refreshlistInfoGroup")
  async loadGroups(name?: string) {
    try {
      this.userTemplateSelectConfig.loadingData = true;
      if (name) {
        await this.handleGroups(name);
        return;
      }
      const filters: InfoGroupQuerySend = {
        state: STATE.ACTIVE,
        paginatedResult: true,
        docRef: this.lastRef
      };

      const responseData = await this.infoGroupService.getInfoGroupByFilters(
        filters
      );

      if (responseData.code === Http.NotFound)
        this.userTemplateSelectConfig.notFound = true;

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        if (this.lastRef) {
          responseData.data.groups.forEach(group => {
            if (group._key !== this.INFO_GROUP_BASIC_ID)
              this.listNameGroup.push(group);
          });
        } else {
          this.listNameGroup = responseData.data.groups;
        }
        this.lastRef = responseData.data.docRef || "";
        this.setInfoGroupList();
      } else {
        this.listNameGroup = [];
        Snackbar.popInfo(USER_TEMP_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_GROUPS);
      }
      this.userTemplateSelectConfig.loadingData = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${INFO_GROUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  changeVisualElement() {
    if (!this.activeSearchSchema) {
      this.infoGroupData.schema["x-display"] = this.visualElement;
    }
  }

  activeSearch() {
    this.activeSearchSchema = true;
  }

  async showPreview() {
    if (this.activeSearchSchema) {
      this.activeSearchSchema = false;

      try {
        const response = await this.userTemplateService.getUserTempSchemaByGroups(
          this.userTemplateFormData.groupsChosen.map(group => group._key)
        );

        if (response.code === Http.Found && response.data != null) {
          Vue.set(
            this.infoGroupData,
            "name",
            this.userTemplateFormData.userTempName
          );
          Vue.set(
            this.infoGroupData,
            "phoneComponentList",
            response.data.phoneComponentList
          );
          Vue.set(this.infoGroupData, "schema", response.data.schema);
          Vue.set(this.infoGroupData.schema, "x-display", this.visualElement);

          this.clearModel = true;
          this.componentPreviewKey = this.componentPreviewKey + 1;
          this.dialogPreview = true;
        } else if (response.code === Http.NotFound) {
          this.infoGroupData.schema.allOf = [];
          this.infoGroupData.phoneComponentList = [];
          Snackbar.popInfo(response.message);
        } else {
          this.infoGroupData.schema.allOf = [];
          this.infoGroupData.phoneComponentList = [];
          Snackbar.popInfo(FORM_MESSAGES.REQUEST_FAILED);
        }
      } catch (error) {
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_TEMPLATES_ACCESS.GET}`
            : FORM_MESSAGES.REQUEST_FAILED;

        Snackbar.popError(errorMessage);
      }
    } else {
      const newOrder: FullSchema[] = [];
      const oldSchema = this.infoGroupData.schema.allOf.slice();

      if (oldSchema !== undefined) {
        this.userTemplateFormData.groupsChosen.forEach(g => {
          const indexAllOf = oldSchema.findIndex(old => old.idGroup === g._key);
          newOrder.push(oldSchema[indexAllOf]);
        });
        this.infoGroupData.schema.allOf = newOrder;
      }
      this.clearModel = true;
      this.dialogPreview = true;
      this.componentPreviewKey = this.componentPreviewKey + 1;
    }
  }

  closeModalPreview() {
    this.dialogPreview = false;
    this.clearModel = false;
    this.infoGroupData.phoneComponentList.forEach(field => {
      field.model = "";
    });
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  @Watch("searchFilter")
  searchGroups() {
    Utils.searchItem(
      this.listNameGroup,
      this.searchFilter,
      NAME_FIELD,
      this.setNotFoundData
    );
  }

  async loadInactiveGroups() {
    const inactiveGroups = this.userTemplateFormData.groupsChosen.filter(
      item => item.state === STATE.INACTIVE
    );

    const inactiveGroupsData: HeaderInfoGroup[] = [];

    if (inactiveGroups) {
      try {
        for (let i = 0; i <= inactiveGroups.length - 1; i++) {
          const response = await this.infoGroupService.getInfoGroupById(
            inactiveGroups[i]._key
          );

          if (response.code === Http.Found) {
            inactiveGroupsData.push(response.data as HeaderInfoGroup);
          }
        }
      } catch (error) {
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${INFO_GROUPS_ACCESS.GET}`
            : FORM_MESSAGES.REQUEST_FAILED;

        Snackbar.popError(errorMessage);
      }
    }

    this.listNameGroup = this.listNameGroup.concat(inactiveGroupsData);
  }

  setNotFoundData(state: boolean) {
    this.noData = state;
  }

  callCancelModal() {
    const modalUserTemplate: SearchContextModal = {
      componentName: COMPONENT_NAME_MODAL.INFO_GROUP,
      callbackHandleOperation: this.handleOperation
    };
    Utils.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
      modalUserTemplate
    );
  }

  async handleOperation(action: string) {
    if (action === LIST_DATA_EVENTS.CANCEL_DATA) {
      this.onCloseList();
    }
  }

  onCloseList() {
    this.showModalAddList = false;
  }

  async addInfoGroup(newInfogroup: InfoGroupModel) {
    try {
      const responseData = await this.infoGroupService.addInfoGroup(
        newInfogroup
      );
      if (responseData.code == Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.showModalAddList = false;

        this.listNameGroup.push({
          _key: newInfogroup._key ?? (responseData.data as string),
          name: newInfogroup.name,
          description: newInfogroup.description,
          state: newInfogroup.state
        });
        this.setInfoGroupList();
      } else {
        Snackbar.popError(
          INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.ERROR_SAVE_INFO_GROUP
        );
      }
      this.showModalAddList = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${INFO_GROUPS_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.USER_TEMPLATE,
      this.userTemplateFormData.userTempName
    );
  }
}
